import React, {useEffect} from "react"
import {graphql} from "gatsby"
import {BlogLayout, Divider, StrapiLayout} from "@klear/open-site";
import {footerData} from "../components/footerData";

const {Helmet} = require("react-helmet");

const styles = require("../styles/index.module.scss");

export default ({ data }) => {
    const post = data.allWordpressPost.edges[0].node;

    useEffect(() => {
        if (typeof window !== "undefined") {
            let url = new URL(window.location.href);
            let searchParams = new URLSearchParams(url.search);
            if (searchParams.get('utm_source') !== null) {
                localStorage.setItem('final_source', searchParams.get('utm_source'));
                if (localStorage.getItem('first_source') === null) {
                    localStorage.setItem('first_source', searchParams.get('utm_source'));
                }
            }
        }
    }, [typeof window])

    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>{post.yoast_head_json.title}</title>
                <meta name="description" content={post.yoast_head_json.description} />
                {post.featured_media && post.featured_media.source_url &&
                <meta name="image" content={post.featured_media.source_url} /> &&
                <meta property="og:image" content={post.featured_media.source_url} />}
            </Helmet>
            <BlogLayout imageUrl={post.featured_media?.source_url} title={post.title} description={post.excerpt} hideDivider>
                <div className={styles.info}>
                    <div className={styles.authorName}>{post.author?.name}</div>
                    <div className={styles.date}>{post.date}</div>
                </div>
                <Divider direction={"horizontal"}/>
                <div dangerouslySetInnerHTML={{ __html: post.content }} />
            </BlogLayout>
        </StrapiLayout>
    )
}
export const query = graphql`
  query($slug: String!) {
    allWordpressPost(filter: { slug: { eq: $slug } }) {
      edges {
        node {
        date(formatString: "MMMM DD, YYYY")
        title
        yoast_head_json {
          title
          description
        }
        content
        slug
        excerpt
        featured_media {
          source_url
        }
        author {
          name
        }
        }
      }
    }
  }
`